<template>
  <div>
    <Breadcrumbs :main="breadcrumbMain" :title="breadcrumbTitle" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>{{ breadcrumbTitle }}</h5>
              <span class="text-muted">This section is coming soon.</span>
            </div>
            <div class="card-body">
              <p class="mb-0">Content for {{ breadcrumbTitle }} will be available here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    breadcrumbMain() {
      return this.$route.meta.breadcrumbMain || ''
    },
    breadcrumbTitle() {
      return this.$route.meta.breadcrumbTitle || 'Page'
    },
  },
}
</script>
